import React from 'react';
import { Backdrop, Box, CircularProgress, Paper, Typography } from '@mui/material';

interface BlockingLoadingOverlayProps {
  open: boolean;
  label: string;
  detail?: string;
}

const BlockingLoadingOverlay: React.FC<BlockingLoadingOverlayProps> = ({ open, label, detail }) => (
  <Backdrop
    open={open}
    sx={(theme) => ({
      color: theme.palette.text.primary,
      zIndex: theme.zIndex.modal + 1,
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(18, 20, 24, 0.48)' : 'rgba(113, 119, 128, 0.24)',
      backdropFilter: 'blur(4px)',
    })}
  >
    <Paper
      elevation={0}
      sx={(theme) => ({
        minWidth: 240,
        maxWidth: 320,
        px: 3,
        py: 2.5,
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(23, 27, 31, 0.9)' : 'rgba(248, 249, 251, 0.92)',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 22px 50px rgba(0, 0, 0, 0.35)'
          : '0 22px 50px rgba(73, 82, 94, 0.18)',
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <CircularProgress size={28} thickness={4.4} />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: 0.1 }}>
            {label}
          </Typography>
          {detail ? (
            <Typography variant="body2" color="text.secondary">
              {detail}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Paper>
  </Backdrop>
);

export default BlockingLoadingOverlay;
